import { inject, Injectable } from '@angular/core';
import {
  getAllowECMPAffiliateLogo,
  getECMPAffiliateLogos,
  JssStateActionTypes,
} from '@core/jss-routing';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, mergeMap } from 'rxjs/operators';
import { selectQueryParams } from '@innogy/utils-state';

import { setEcmpAffiliateLogo } from './ecmp-logos.actions';
import type { SCEcmpAffiliateLogo } from './ecmp-logos.interface';

@Injectable()
export class EcmpLogosEffects {
  readonly actions$ = inject(Actions);
  readonly store$ = inject(Store);

  readonly allowECMPAffiliateLogo$ = this.store$.select(
    getAllowECMPAffiliateLogo
  );
  readonly affiliateLogos$ = this.store$.select(getECMPAffiliateLogos);
  readonly queryParams$ = this.store$.select(selectQueryParams);

  public readonly onJssStateUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JssStateActionTypes.UPDATE),
      concatLatestFrom(() => [
        this.allowECMPAffiliateLogo$,
        this.queryParams$,
        this.affiliateLogos$,
      ]),
      filter(([, allowEcmpLogo, { ecmp }]) => allowEcmpLogo && ecmp),
      mergeMap(([, , { ecmp }, ecmpLogos]) => {
        const ecmpLogo = (ecmpLogos as SCEcmpAffiliateLogo[]).find((logo) =>
          ecmp.includes(logo.fields.ecmp?.value)
        );
        return ecmpLogo
          ? [
              setEcmpAffiliateLogo({
                ecmpLogo,
              }),
            ]
          : [];
      })
    )
  );
}
